const renderBoolean = (params) => {
  return params.value === true ? (
    <>
      <i style={{color: "#3FBB6190", fontSize: "1rem" }} className="fas fa-check"></i>
    </>
  ) : (
    <i style={{color: "#EA283990", fontSize: "1rem" }} className="fas fa-times"></i>
  );
};

export default renderBoolean;
